import $ from 'jquery';

export default function setCalendarTitle(prefix, cssSel){
    var title = $(cssSel).fullCalendar("getView").title;
    this.dataSet(prefix+"/title", title);
}